import styled from "@emotion/styled";

const RightBottomExtWrapper = styled.div`
	height: 100%;
	width: 100%;
	z-index: var(--z-index-base);
	display: flex;
	align-items: end;
	justify-content: right;
	padding: 0.5rem;
	position: absolute;
`;

export default RightBottomExtWrapper;
